/** localStorage key holding "light" | "dark" (absent = follow the system). */
export const THEME_STORAGE_KEY = "bx_theme";

/**
 * Inline script for <head>: applies the stored theme before first paint to
 * avoid a flash. Keep in sync with `setTheme`.
 */
export const THEME_INIT_SCRIPT = `(function(){try{var p=localStorage.getItem("${THEME_STORAGE_KEY}");var d=p==="dark"||(p!=="light"&&matchMedia("(prefers-color-scheme: dark)").matches);var e=document.documentElement;e.classList.toggle("dark",d);e.style.colorScheme=d?"dark":"light";}catch(_){}})();`;
